/****************************************************
 * Module Name:  proforma.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import React, { useState } from "react";
import { DataGridPro, GridToolbar, GridToolbarExport, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import {
  Box,
  Button,
  Tooltip,
  Typography,
  Stack
} from "@mui/material";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import { useEffect } from "react";
import Select from "react-select";
import CircularProgress from "@mui/material/CircularProgress";
import NoPermission from "../common/noPermission";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import Utility from "../../utility/utility";
import Constants from "../../utility/constants";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import CommonSnackbar from "../common/commonSnackBar";
import { FaFileInvoice } from "react-icons/fa";
import DeleteIcon from "@mui/icons-material/Delete";
import MixSaleProxy from "../../utility/proxy/manager/mixProxy/mixSalesProxy";
import DeleteMixProformaModal from "./deleteMixProformaModal";
import AddSaleModal from "./addSaleModal";
import BucketDetailModal from "../mixDiamondSales/bucketDetailModal";
import renderCellExpand from "../common/dataGridCellExpand";
import { LoadingButton } from "@mui/lab";
import PageTitle from "../common/pageTitle";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import UserDetailModal from "../operations/userDetailModal";

const MixSalesProforma = () => {

  const local_Permission = Constants.USER_PERMISSION.filter((iPermission) =>
    iPermission.permissionid === Constants.PERMISSIONS.MIX_SALES_PROFORMA);

  const proformaEdit = Constants.USER_PERMISSION.filter((iPermission) =>
    iPermission.permissionid === Constants.PERMISSIONS.UPDATEMIXINVOICEDATA);

  const invoice_Permission = Constants.USER_PERMISSION.filter((iPermission) =>
    iPermission.permissionid === Constants.PERMISSIONS.DIRECTMIXINVOICE);

  const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);
  const [showSellModal, setShowSellModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [snackbarVariant, setSnackbarVariant] = useState("");
  const [customerData, setCustomerData] = useState({
    customer: "",
    customerOptions: [],
  });
  const [stoneData, setStoneData] = useState([]);
  const [listData, setListData] = useState([]);
  const [mainData, setMainData] = useState([]);
  const [selectedProformas, setSelectedProformas] = useState([]);
  const [loadingButton, setLoadingButton] = useState(false);
  const [loadingDeleteButton, setLoadingDeleteButton] = useState(false);
  const [memoLoader, setMemoLoader] = useState(false);
  const [selectionModel, setSelectionModel] = useState([]);
  const [show, setShow] = useState(false);
  const [proformaIds, setProformaIds] = useState([]);
  const [deleteModalTitle, setDeleteModalTitle] = useState("");
  const [flag, setFlag] = useState(true);
  const [filterValues, setFilterValues] = useState({});
  const [showBucketDetailModal, setShowBucketDetailModal] = useState(false);
  const [bucketId, setBucketId] = useState([]);

  const [customerLoader, setCustomerLoader] = useState(false);
  const [showUserDetailModal, setShowUserDetailModal] = useState(false);


  useEffect(() => {
    PageTitle("MIX_SALES_PROFORMA");
    if (Constants.loggedInUser.usertype === "E") {
      prepareUserData();
    }
  }, []);

  const prepareUserData = () => {
    setCustomerLoader(true);
    MixSaleProxy.GetCustomersCreatedProforma(
      Utility.isReadAllowed(local_Permission) ? Constants.loggedInUser.locationid : -1,
      Utility.isReadAllowed(local_Permission) ? -1 : Constants.loggedInUser.id,
      Constants.loggedInUser.usertype,
      (response) => {
        if (response) {
          setAllUserData(response);
          setCustomerLoader(false);
        }
      });
  };

  const setAllUserData = (response) => {
    let optionsArray = [];
    optionsArray.push({ value: "*", label: "-- ANY --" });
    response.map((data) => {
      let option = {
        value: data.id,
        label: data.companyname,
      };
      optionsArray.push(option);
      return true;
    });
    setCustomerData({
      ...customerData,
      customerOptions: optionsArray,
      customer:
        customerData.customer === "" && optionsArray.length > 0
          ? [optionsArray[0]]
          : customerData.customer,
    });
  };

  useEffect(() => {
    if (flag && customerData.customerOptions.length > 0)
      handleSearch();
  }, [customerData.customerOptions]);

  const fullOptionToValue = (selectedData) => {
    let newArr = [];
    selectedData.map((data) => {
      if (data.value === "*") {
        return customerData.customerOptions.map((option) => {
          if (option.value !== "*") {
            newArr.push(option.value);
            return true;
          }
          return true;
        });
      }
      return true;
    })
    return Utility.GetValueArrayWithStarReplace(selectedData, newArr);
  };

  const handleSearch = () => {
    let data = {
      customerid: fullOptionToValue(customerData.customer),
      status: ["NEW", "INPROGRESS"],
    };
    setMemoLoader(true);
    MixSaleProxy.GetAllProformaOpen(data, (response) => {
      if (response) {
        const uniqueFilterValues = {
          status: Utility.getDistinctOptions(response, "status"),
          exchangecurrency: Utility.getDistinctOptions(response, "exchangecurrency"),
          user: Utility.getDistinctOptions(response, "userid"),
          broker: Utility.getDistinctOptions(response, "brokerid"),
          customer: Utility.getDistinctOptions(response, "customerid"),
          invoicecustomer: Utility.getDistinctOptions(response, "invoicecustomerid"),
          tradingcompany: Utility.getDistinctOptions(response, "tradingcompanyid"),
        };

        const bucketNames = [];
        response.forEach(item => {
          if (item.buckets && item.buckets.length > 0) {
            item.buckets.forEach(bucket => {
              const bucketName =
                `${bucket.stonetypefullname} | ${bucket.shape} | ${bucket.size} | ${bucket.color} | ${bucket.clarity}`;
              if (!bucketNames.includes(bucketName)) {
                bucketNames.push(bucketName);
              }
            });
          }
        });

        const combinedFilterValues = {
          status: uniqueFilterValues.status,
          exchangecurrency: uniqueFilterValues.exchangecurrency,
          user: uniqueFilterValues.user.map(value => {
            const matchingItem = response.find(item => item.userid === value);
            return matchingItem ? `${value} | ${matchingItem.username}` : [];
          }),
          broker: uniqueFilterValues.broker.map(value => {
            const matchingItem = response.find(item => item.brokerid === value);
            if (matchingItem) {
              let displayValue = matchingItem.brokerid === -1 ? " - " : `${matchingItem.brokerid} | ${matchingItem.brokername}`;
              return displayValue;
            }
            return [];
          }),
          customer: uniqueFilterValues.customer.map(value => {
            const matchingItem = response.find(item => item.customerid === value);
            return matchingItem ? `${value} | ${matchingItem.customername}` : [];
          }),
          tradingcompany: uniqueFilterValues.tradingcompany.map(value => {
            const matchingItem = response.find(item => item.tradingcompanyid === value);
            return matchingItem ? `${value} | ${matchingItem.tradingcompanyname}` : [];
          }),
          bucketname: bucketNames,
        };
        setFilterValues(combinedFilterValues);
        setSelectionModel([])
        setListData(response);
        handleArray(response);
        setMemoLoader(false);
        setFlag(false);
      } else {
        setMemoLoader(false);
        setShowSuccessSnackbar(true);
        setSuccessMessage(Constants.APiFailErrorMessage);
        setSnackbarVariant("error");
      }
    });
  };

  const sellStones = (data) => {
    setLoadingButton(true);
    MixSaleProxy.MixSellInvoice(data, (responseData) => {
      if (responseData) {
        handleSearch();
        setShowSellModal(false);
        setShowSuccessSnackbar(true);
        setSuccessMessage("Buckets sold successfully");
        setSnackbarVariant("success");
        setLoadingButton(false);
      } else {
        setShowSuccessSnackbar(true);
        setSuccessMessage(Constants.APiFailErrorMessage);
        setSnackbarVariant("error");
        setLoadingButton(false);
      }
    });
  };

  const handleProforma = (data) => {
    setLoadingButton(true);
    MixSaleProxy.MixSellProforma(data, (responseData) => {
      if (responseData) {
        handleSearch();
        setShowSellModal(false);
        setShowSuccessSnackbar(true);
        setSuccessMessage("Proforma Updated successfully");
        setSnackbarVariant("success");
        setLoadingButton(false);
      } else {
        setShowSuccessSnackbar(true);
        setSuccessMessage(Constants.APiFailErrorMessage);
        setSnackbarVariant("error");
        setLoadingButton(false);
      }
    });
  };

  const handleValidation = (customer) => {
    //TODO do validation if needed here
    return true;
  };

  const handleBucketDetailModal = (params) => {
    setBucketId(params.value);
    setShowBucketDetailModal(true)
  };

  const handleArray = (lListData) => {
    let newMainData = [];
    if (lListData.length > 0) {
      lListData.map((list) => {
        list.buckets.map((stone) => newMainData.push(stone));
        return true;
      });
    }
    setMainData(newMainData);
  };

  const handleClose = () => {
    setShowSuccessSnackbar(false);
  };

  const handleProformaDelete = (id, message) => {
    setLoadingDeleteButton(true);
    MixSaleProxy.DeleteProforma(id, (response) => {
      if (response) {
        setShow(false);
        handleSearch();
        setShowSuccessSnackbar(true);
        setSuccessMessage(message);
        setSnackbarVariant("success");
        setLoadingDeleteButton(false);
      } else {
        setShowSuccessSnackbar(true);
        setSuccessMessage(Constants.APiFailErrorMessage);
        setSnackbarVariant("error");
        setLoadingDeleteButton(false);
      }
    });
  };

  const columnName = [
    {
      field: "id",
      headerName: "ID",
      headerAlign: "center",
      width: 80,
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
    },
    {
      field: "perfomaid",
      headerName: "PROFORMA ID",
      headerAlign: "center",
      width: 80,
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
    },
    {
      field: "bucketid",
      headerName: "BUCKETID",
      headerAlign: "center",
      align: "center",
      width: 80,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => (Utility.NeedToShowBucketDetailModal()) ?
        <Button
          sx={{
            textDecorationLine: "underline",
            color: 'black'
          }}
          onClick={() => handleBucketDetailModal(params)}
        >
          {params.value}
        </Button>
        :
        <div>{params.value}</div>,
    },
    {
      field: "bucketname",
      headerName: "BUCKET NAME",
      headerAlign: "center",
      align: "center",
      width: 300,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.bucketname : [],
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) =>
        params.row.stonetypefullname +
        " | " +
        params.row.shape +
        " | " +
        params.row.size +
        " | " +
        params.row.color +
        " | " +
        params.row.clarity,
      renderCell: (params) =>
        params.row.stonetypefullname +
        " | " +
        params.row.shape +
        " | " +
        params.row.size +
        " | " +
        params.row.color +
        " | " +
        params.row.clarity,
    },
    {
      field: "qty",
      headerName: "QTY",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 55,
    },
    {
      field: "piece",
      headerName: "PIECES",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 70,
    },
    {
      field: "sellqty",
      headerName: "SELL QTY",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 80,
    },
    {
      field: "price",
      headerName: "PPC",
      headerAlign: "center",
      align: "right",
      width: 70,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.price)
    },
    {
      field: "discount1",
      headerName: "DIS 1",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 55,
    },
    {
      field: "discount2",
      headerName: "DIS 2",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 55,
    },
    {
      field: "discount3",
      headerName: "DIS 3",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 55,
    },
    {
      field: "final_amount",
      headerName: "FINAL AMOUNT",
      headerAlign: "center",
      align: "center",
      width: 110,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.final_amount)
    },
    {
      field: "remarks",
      headerName: "REMARKS",
      headerAlign: "center",
      align: "center",
      width: 90,
      renderCell: renderCellExpand
    },
  ];

  const materialDefaultColumns = [
    {
      headerName: "CONVERT TO INVOICE",
      field: "converttoinvoice",
      width: 150,
      align: "center",
      renderCell: (params) => {
        return (
          <Tooltip title="Convert this Proforma to Invoice">
            <Button
              variant="contained"
              component="label"
              size="small"
              startIcon={<FaFileInvoice />}
              color="success"
              onClick={(e) => {
                e.stopPropagation()
                setShowSellModal(!showSellModal);
                setStoneData(() =>
                  mainData.filter((data) => data.perfomaid === params.row.id)
                );
                setSelectedProformas([params.row]);
              }}
            >
              Proforma
            </Button>
          </Tooltip >
        )
      },
    },
    {
      headerName: "DELETE PROFORMA",
      field: "deleteproforma",
      width: 140,
      align: "center",
      renderCell: (params) => {
        return (
          <Tooltip title="Delete this Proforma">
            <Button
              variant="contained"
              component="label"
              size="small"
              startIcon={<DeleteIcon size="large" />}
              color="error"
              onClick={(e) => {
                e.stopPropagation()
                let ids = [];
                params.row.buckets.map((stone) =>
                  ids.push({
                    bucketid: stone.bucketid,
                    performaid: stone.perfomaid,
                    id: stone.id
                  })
                );
                setShow(true);
                setProformaIds(ids);
                setDeleteModalTitle(
                  "Are you sure you want to Delete this Proforma ?"
                );
              }}
            >
              Delete
            </Button>
          </Tooltip>
        )
      },
    },
    {
      headerName: "PROFORMA ID",
      field: "id",
      headerAlign: "center",
      width: 130,
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      renderCell: renderCellExpand
    },
    {
      headerName: "STONETYPE",
      field: "stonetype",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.stonetype.map(option => option.fullname),
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) => Constants.STONE_TYPE[params.value],
      renderCell: (params) => Constants.STONE_TYPE[params.value],
      width: 115,
    },
    {
      headerName: "USER",
      field: "userid",
      width: 130,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.user : [],
      filterOperators: Utility.combinedFilters(),
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => {
        return `${params.row.userid} | ${params.row.username}`;
      },
      renderCell: (params) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ marginRight: '5px', marginLeft: '10px' }}>
            {`${params.row.userid} | ${params.row.username}`}
          </span>
        </div>
      ),
    },
    {
      headerName: "BROKER COMPANY",
      field: "brokerid",
      width: 150,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.broker : [],
      filterOperators: Utility.combinedFilters(),
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => {
        return `${params.row.brokerid} | ${params.row.brokername}`;
      },
      renderCell: (params) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ marginRight: '5px', marginLeft: '10px' }}>
            {(params.row.brokerid === -1 || params.row.brokerid === null) ? " - " : `${params.row.brokerid} | ${params.row.brokername}`}
          </span>
        </div>
      ),
    },
    {
      headerName: "CUSTOMER COMPANY",
      field: "customerid",
      width: 200,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.customer : [],
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) => {
        return `${params.row.customerid} | ${params.row.customername}`;
      },
      renderCell: (params) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: '5px', marginLeft: '10px' }}>
              {`${params.row.customerid} | ${params.row.customername}`}
            </span>
          </div>
        );
      },
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "TRADING COMPANY",
      field: "tradingcompanyid",
      width: 200,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.tradingcompany : [],
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) => {
        return `${params.row.tradingcompanyid} | ${params.row.tradingcompanyname}`;
      },
      renderCell: (params) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: '5px', marginLeft: '10px' }}>
              {`${params.row.tradingcompanyid} | ${params.row.tradingcompanyname}`}
            </span>
          </div>
        );
      },
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "EXCHANGE CURRENCY",
      field: "exchangecurrency",
      headerAlign: "center",
      align: "center",
      width: 170,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.exchangecurrency : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand
    },
    {
      headerName: "EXCHANGE RATE",
      field: "exchangerate",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 130,
      renderCell: renderCellExpand
    },
    {
      headerName: "DAYS",
      field: "days",
      headerAlign: "center",
      align: "center",
      width: 55,
      renderCell: renderCellExpand
    },
    {
      headerName: "SHIPPING COST",
      field: "shippingcost",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 110,
      renderCell: renderCellExpand
    },
    {
      headerName: "FINAL PAYABLE AMOUNT",
      field: "finalpayableamount",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 170,
      renderCell: renderCellExpand
    },
    {
      headerName: "DATE",
      field: "date",
      type: "date",
      width: 85,
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => Utility.ConvertUtcToLocalDate(params.row.date),
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "EXPORT",
      field: "export",
      renderCell: (params) =>
        params.row.export ? (
          <CheckIcon color="success" />
        ) : (
          <ClearIcon color="error" />
        ),
      headerAlign: "center",
      align: "center",
      width: 65
    },
    {
      headerName: "COUNTRY OF FINAL DESTINATION",
      field: "countryoffinaldestination",
      headerAlign: "center",
      align: "center",
      width: 225,
      renderCell: renderCellExpand
    },
    {
      headerName: "COUNTRY OF ORIGIN",
      field: "countryoforigin",
      headerAlign: "center",
      align: "center",
      width: 145,
      renderCell: renderCellExpand
    },
    {
      headerName: "FINAL DESTINATION",
      field: "finaldestination",
      headerAlign: "center",
      align: "center",
      width: 135,
      renderCell: renderCellExpand
    },
    {
      headerName: "ENSURED BY",
      field: "ensuredby",
      headerAlign: "center",
      align: "center",
      width: 95,
      renderCell: renderCellExpand
    },
    {
      headerName: "BANK THROUGH",
      field: "bankthrough",
      renderCell: (params) =>
        params.row.bankthrough ? (
          <CheckIcon color="success" />
        ) : (
          <ClearIcon color="error" />
        ),
      headerAlign: "center",
      width: 115,
      align: "center",
    },
    {
      headerName: "PORT OF LOADING",
      field: "portofloading",
      headerAlign: "center",
      align: "center",
      width: 130,
      renderCell: renderCellExpand
    },
    {
      headerName: "SHIPPED BY",
      field: "shippedby",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand
    },
    {
      headerName: "PORT OF DISCHARGE",
      field: "portofdischarge",
      headerAlign: "center",
      align: "center",
      width: 150,
      renderCell: renderCellExpand
    },
    {
      headerName: "REMARKS",
      field: "remarks",
      headerAlign: "center",
      align: "center",
      width: 75,
      renderCell: renderCellExpand
    },
    {
      headerName: "TERMS",
      field: "terms",
      align: "center",
      width: 55,
      renderCell: renderCellExpand
    },
    {
      headerName: "DUE DATE",
      field: "duedate",
      type: "date",
      width: 85,
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => Utility.ConvertUtcToLocalDate(params.row.duedate),
      headerAlign: "center",
      align: "center",
    },
  ];

  const columns = columnName;

  const getDetailPanelHeight = React.useCallback(() => 'auto', []);

  const getDetailPanelContent = React.useCallback(
    (row, mainData) => <DetailPanelContent row={row} mainData={mainData} />,
    [columns],
  );

  function DetailPanelContent({ row: rowProp, mainData }) {
    let row = mainData.filter(data => data.perfomaid === rowProp.id);
    return (
      <Stack
        sx={{ p: 1, boxSizing: 'border-box', borderBottom: "1px solid lightgrey" }}
        direction="column"
      >
        <Box
          sx={{
            backgroundColor: '#fff',
            color: '#000',
            width: "53.5vw",
            position: "relative",
            "& .MuiTablePagination-selectLabel": {
              marginTop: "15px",
            },
            "& .MuiTablePagination-displayedRows": {
              marginTop: "15px",
            },
            "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
              fontWeight: Constants.defaultFontWeight,
            },
            "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
              color: "#1976d2",
              padding: "4px 5px",
              borderRadius: "4px",
            },
            "& .css-cc8tf1": {
              fontWeight: Constants.defaultFontWeight,
            },
            height: 'auto'
          }}
        >
          <DataGridPro
            disableRowSelectionOnClick={false}
            density="compact"
            columns={columns}
            rows={row}
            getRowId={(row) => row.id}
            sx={{
              '& .MuiDataGrid-columnHeader': {
                color: '#fff',
                backgroundColor: 'grey',
              },
              "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                py: "8px",
              },
              "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                py: "15px",
              },
              "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                py: "22px",
              },

              fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
              maxHeight: '35vh'
            }}
            slots={{ toolbar: GridToolbar }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
              },
            }}
            initialState={{
              columns: {
                columnVisibilityModel: {
                  // Hide columns id, the other columns will remain visible
                  perfomaid: false,
                  id: false,
                },
              },
            }}
            hideFooter
          />
        </Box>
      </Stack>
    );
  }

  const isEmployee = Constants.loggedInUser.usertype === "E";
  const canUpdate = Utility.isUpdateAllowed(local_Permission) || Utility.isUpdateAllowed(invoice_Permission);
  const canDelete = Utility.isDeleteAllowed(local_Permission);
  const materialColumns = isEmployee ? (
    canUpdate && canDelete ? materialDefaultColumns : (
      canUpdate || canDelete ?
        materialDefaultColumns.filter((col) => canUpdate ? col.field !== "deleteproforma" : col.field !== "converttoinvoice") :
        materialDefaultColumns.filter((col) => col.field !== "deleteproforma" && col.field !== "converttoinvoice")
    )
  ) : materialDefaultColumns.filter((col) => col.field !== "deleteproforma" && col.field !== "converttoinvoice");

  function CustomToolbar() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          alignItems: "center",
          marginHorizontal: "5px",
          "&.MuiDataGrid-toolbarContainer": {
            padding: "0px 4px !important",
          },
        }}
      >
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarExport />
        <Box sx={{ flexGrow: 1, display: { sm: "none", md: "block" } }} />
        {memoLoader ? (
          <CircularProgress size="1rem" />
        ) : (
          <Tooltip title="Reload List">
            <RefreshOutlinedIcon
              onClick={() => handleSearch()}
              color="primary"
              fontSize="medium"
              sx={{ cursor: "pointer", mt: 1 }}
            />
          </Tooltip>
        )}
        <GridToolbarQuickFilter debounceMs={500} />
      </GridToolbarContainer>
    );
  }

  return (
    <div className="background">

      {showSuccessSnackbar ? (
        <CommonSnackbar
          show={true}
          message={successMessage}
          variant={snackbarVariant}
          autoHide={Constants.SnackBarCloseTimer}
          title={snackbarVariant === "success" ? "Success" : "Failed"}
          handleClose={handleClose}
        />
      ) : null}

      {showSellModal ? (
        <AddSaleModal
          sourceData={selectedProformas}
          show={true}
          setShow={() => setShowSellModal(false)}
          handleValidation={handleValidation}
          handleProforma={handleProforma}
          handleInvoice={sellStones}
          stoneId={selectionModel}
          stockData={stoneData}
          customer={{
            value: selectedProformas[0].customerid,
            label: selectedProformas[0].customercompanyname
          }}
          user={Constants.loggedInUser.id + " | " + Constants.loggedInUser.companyname}
          proformaButton={false}
          loading={loadingButton}
          notPermitted={!Utility.isUpdateAllowed(proformaEdit)}
          bucketDisabled={true}
        />
      ) : null}

      {show ? (
        <DeleteMixProformaModal
          show={show}
          setShow={setShow}
          handleValidation={handleValidation}
          handleSave={handleProformaDelete}
          proformaIds={proformaIds}
          deleteModalTitle={deleteModalTitle}
          loading={loadingDeleteButton}
        />
      ) : null}

      {showBucketDetailModal ? (
        <BucketDetailModal
          show={showBucketDetailModal}
          bucketId={bucketId}
          handleClose={() => setShowBucketDetailModal(false)}
        />
      ) : null}

      {showUserDetailModal ? (
        <UserDetailModal
          show={true}
          handleClose={() => setShowUserDetailModal(false)}
          handleSelect={(selectedOption) => {
            const selectedCustomers = customerData.customerOptions.filter(opt =>
              selectedOption.includes(opt.value)
            );
            setCustomerData({
              ...customerData,
              customer: selectedCustomers,
            })
            setShowUserDetailModal(false)
          }}
          userids={customerData.customerOptions.filter(option => option.value !== "*").map(cust => cust.value)}
          selectedIds={customerData.customer.length !== 0 ? customerData.customer.map(iCust => iCust.value) : []}
          usertype={"C"}
          loading={showUserDetailModal}
          isMulti={true}
        />
      ) : null}

      {Constants.loggedInUser.usertype !== "E" ? <NoPermission /> : (
        <Box px={1}>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              rowGap: 2,
              columnGap: 2,
              my: 1,
              width: "100%",
            }}
          >
            {/* Label */}
            <Box sx={{ whiteSpace: "nowrap" }}>
              <Typography>Customer Company</Typography>
            </Box>

            {/* Select + Icon */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexGrow: 1,
                minWidth: { xs: "200px", sm: "250px", md: "300px" },
                maxWidth: { xs: "100%", sm: "350px" },
                width: "100%",
              }}
            >
              <Box sx={{ flexGrow: 1 }}>
                <Select
                  menuPlacement="auto"
                  blurInputOnSelect={false}
                  isMulti
                  className="basic-single"
                  classNamePrefix="select"
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  value={customerData.customer}
                  isSearchable={true}
                  name="Customer"
                  menuPortalTarget={document.body}
                  styles={Constants.Styles}
                  options={customerData.customerOptions}
                  onChange={(selectedOption) => {
                    setCustomerData({
                      ...customerData,
                      customer: selectedOption,
                    });
                  }}
                  // add this to keep the menu portal correctly sized if needed:
                  menuShouldScrollIntoView={false}
                />
              </Box>
              <Tooltip title="View More Data">
                <span style={{ cursor: "pointer", marginLeft: "8px" }}>
                  <OpenInNewIcon
                    fontSize="medium"
                    color="action"
                    onClick={() => setShowUserDetailModal(true)}
                  />
                </span>
              </Tooltip>
            </Box>

            {/* Reload Icon */}
            <Box>
              {customerLoader ? (
                <CircularProgress size="1rem" />
              ) : (
                <Tooltip title="Reload Customer Company">
                  <RefreshOutlinedIcon
                    onClick={() => prepareUserData()}
                    color="primary"
                    fontSize="medium"
                    sx={{ cursor: "pointer" }}
                  />
                </Tooltip>
              )}
            </Box>

            {/* Search Button */}
            <LoadingButton
              variant="contained"
              onClick={handleSearch}
              startIcon={<SearchOutlinedIcon size="large" />}
              loading={memoLoader}
              loadingPosition="start"
              disabled={customerData.customerOptions.length === 0}
              sx={{
                whiteSpace: "nowrap",
              }}
            >
              Search
            </LoadingButton>
          </Box>

          <Box
            sx={{
              backgroundColor: '#fff',
              color: '#000',
              width: "100%",
              position: "relative",
              "& .MuiTablePagination-selectLabel": {
                marginTop: "15px",
              },
              "& .MuiTablePagination-displayedRows": {
                marginTop: "15px",
              },
              "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                fontWeight: Constants.defaultFontWeight,
              },
              "& .css-cc8tf1": {
                fontWeight: Constants.defaultFontWeight,
              },
              "& .lavenderCell": {
                color: "#080808",
                backgroundColor: "#D8BFD8",
              },
              height: "80vh",
            }}
          >
            <DataGridPro
              rowHeight={65}
              disableRowSelectionOnClick={false}
              density="compact"
              columns={materialColumns}
              rows={listData}
              loading={memoLoader}
              sx={{
                '& .MuiDataGrid-columnHeader': {
                  color: '#fff',
                  backgroundColor: 'grey',
                },
                "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                  py: "4px",
                },
                "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                  py: "12px",
                },
                "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                  py: "18px",
                },

                '& .MuiDataGrid-row': {
                  whiteSpace: 'nowrap',
                },
                fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
              }}
              slots={{ toolbar: CustomToolbar }}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
              getRowId={(row) => row.id}
              initialState={{
                pagination: {
                  paginationModel: Constants.pageSize,
                },
              }}
              sortModel={[
                {
                  field: 'id',
                  sort: 'desc',
                },
              ]}
              pageSizeOptions={Constants.pageSizeOptions}
              pagination
              getDetailPanelHeight={getDetailPanelHeight}
              getDetailPanelContent={({ row }) => getDetailPanelContent(row, mainData)}
            />
          </Box>
        </Box>
      )}
    </div>
  );
};

export default MixSalesProforma;
